import { ReactComponent as Icon } from "./save.svg";

const SaveIcon = () => {
    return <Icon />;
}

export default SaveIcon;